$(document).ready(function () {

    /**
     * Bouttons fixé en bas à droite de l'écran
     */
    var $btnActionsBottomRightFixed = $('.btn-bottom-right-fixed');
    $btnActionsBottomRightFixed.hide();
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 800) {
                $btnActionsBottomRightFixed.fadeIn();
            } else {
                $btnActionsBottomRightFixed.fadeOut();
            }
        });
    });

});
